module.exports = __webpack_public_path__ + "static/media/step2.bb764f15.svg";